import { useState } from "react";
import { adminTranslateField } from "@/lib/api";
import { toast } from "sonner";
import { Languages, Loader2 } from "lucide-react";

// Tiny inline widget: translate THIS field's English value into one picked
// language (saved as that language's draft). Drop it next to any editor field.
export default function InlineTranslate({ itemId, field, text, languages = [] }) {
  const [busy, setBusy] = useState(false);
  if (!itemId || !languages.length) return null;

  const run = async (code) => {
    if (!code) return;
    const src = (text || "").replace(/<[^>]+>/g, " ").replace(/&nbsp;/g, " ").trim();
    if (!src) { toast.error("Fill the English value first, then translate."); return; }
    setBusy(true);
    try {
      await adminTranslateField(itemId, field, code, text);
      const l = languages.find((x) => x.code === code);
      toast.success(`Translated into ${l?.native_label || l?.label || code}`, {
        description: "Saved as a draft — review & publish it under Translations below.",
      });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Translation failed.");
    } finally { setBusy(false); }
  };

  return (
    <span className="inline-flex items-center gap-1" data-testid={`inline-tr-${field}`} title="Translate just this field into one language">
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin text-saffron" /> : <Languages className="h-3.5 w-3.5 text-gold" />}
      <select
        disabled={busy}
        value=""
        onChange={(e) => { const v = e.target.value; e.target.value = ""; run(v); }}
        data-testid={`inline-tr-select-${field}`}
        className="border border-line bg-parchment px-1.5 py-0.5 text-[11px] text-ink-2 focus:border-saffron focus:outline-none"
      >
        <option value="">Translate to…</option>
        {languages.map((l) => <option key={l.code} value={l.code}>{l.native_label || l.label}</option>)}
      </select>
    </span>
  );
}
